import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { Container, FlexContainer, H2 } from "@carrotfertility/carotene"
import useButtonSingleSelect from "../../hooks/useButtonSingleSelect"
import ButtonSelectGroup from "../../shared/ButtonSelectGroup"
import { useRoutingInfo } from "components/carrot-plans/context/RoutingInfoContext"
import ArrowSubmitButton from "components/carrot-plans/shared/ArrowSubmitButton"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"

const ViewName = Steps.IVF_INFORMATION
export default function IvfInformationStep(): JSX.Element {
  const { routingData, updateRoutingInfo } = useRoutingInfo()
  const defaultValue = routingData?.interestNoIvf
  const { setNextStep } = useStateMachine(ViewName, defaultValue)
  const { handleContinueLoading, continueLoading } = useJourneyFlow()
  const { valid, ...buttonProps } = useButtonSingleSelect({
    options: [
      { title: "Yes", id: "YES" },
      { title: "No", id: "NO" }
    ],
    defaultValue,
    onSubmit: onClickContinue
  })
  async function onClickContinue(selectedValue: string): Promise<void> {
    if (selectedValue !== null) {
      await handleContinueLoading(() => updateRoutingInfo({ interestNoIvf: selectedValue }))
      setNextStep(ViewName, selectedValue)
    }
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onClickContinue(defaultValue)
      }}
    >
      <H2 stack="large">
        Your answers indicate that IVF may be a possibility now or in the future.
        <br />
        <br />
        Are you interested in learning about evidence-based fertility options that can help some people get pregnant
        without IVF?
      </H2>
      <Container>
        <ButtonSelectGroup {...buttonProps} />
      </Container>
      <FlexContainer paddingTopBottom="huge" justifyContent="flex-end">
        <ArrowSubmitButton enabled={valid && !continueLoading}>Continue</ArrowSubmitButton>
      </FlexContainer>
    </form>
  )
}
